import { useTranslation } from 'react-i18next';
import Button from 'components/Button/Button';
import { BUTTON_VARIANT } from 'constants/interfaces';

import EmptyTaskManagement from '../../../../components/EmptyTaskManagement/EmptyTaskManagement';
import InsightsDashboardChart from './InsightsDashboardChart';
import InsightsDashboardFilters from './InsightsDashboardFilters';
import InsightsDashboardRank from './InsightsDashboardRank';

import type IInsightsDashboard from '../interfaces/IInsightsDashboard';

import styles from '../scss/MAInsightsDashboard.module.scss';

function InsightsDashboard({
  control,
  dashboardData,
  templatesData,
  dashboardTopics,
  showActionButtons,
  onClearAll,
  onGenerate,
  setSliderWrapper,
  handleCancelDashboard,
  handleNext,
  setValue,
  options,
  handlePrev,
}: IInsightsDashboard) {
  const { t } = useTranslation();

  return (
    <div className={styles.root}>
      <p className={styles.header}>{t('materialityAssessment.phaseGatherInsight')}</p>
      <div className={styles.titleWrapper}>
        <p>{t('materialityAssessment.insightsDashboard')}</p>
        <Button
          title={t('materialityAssessment.settingWeighting')}
          variant={BUTTON_VARIANT.cancel}
          className={styles.button}
          onClick={() => setSliderWrapper(true)}
        />
      </div>
      <div className={styles.rootContainer}>
        <div className={styles.contentWrapper}>
          <InsightsDashboardFilters
            control={control}
            templatesData={templatesData}
            dashboardTopics={dashboardTopics}
            showActionButtons={showActionButtons}
            onClearAll={onClearAll}
            onGenerate={onGenerate}
            setValue={setValue}
            vcOptions={options}
          />
          {(dashboardData && dashboardData?.global.length > 0) ? (
            <div className={styles.content}>
              <InsightsDashboardChart
                dashboardData={dashboardData}
              />
              <InsightsDashboardRank dashboardData={dashboardData} />
            </div>
          ) : (
            <EmptyTaskManagement
              title={t('materialityAssessment.emptyChartData')}
            />
          )}
        </div>
        <div className={styles.buttonWrapper}>
          <Button
            title={t('common.cancel')}
            variant={BUTTON_VARIANT.cancel}
            className={styles.button}
            onClick={handleCancelDashboard}
          />
          <div className={styles.rightButtons}>
            <Button
              title={t('common.prev')}
              onClick={handlePrev}
              variant={BUTTON_VARIANT.cancel}
              className={styles.prevButton}
            />
            <Button
              title={t('common.next')}
              onClick={handleNext}
              className={styles.button}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default InsightsDashboard;
